import { Component, Input } from '@angular/core';
import { CardElementsBaseComponent } from '../card-elements-base.component';
import { WorkflowService } from '../../../../service/workflow/workflow.service';
import { CardInstance } from '@workflow/class/card.service';

@Component({
  selector: 'cu-dynamic-card-fields',
  templateUrl: './card-fields.component.html'
})
export class CardFieldsComponent extends CardElementsBaseComponent {
  @Input() public cardId;

  constructor(private readonly workflowService: WorkflowService) {
    super();
  }

  public visibleCards(): CardInstance[] {
    return this.workflowService.currentPage.cards.filter((card) => card.visible);
  }

  // TEMP: this needs to be handled by the workflow to validate all nested fields recursively
  public allFieldsInCardValid(fields): boolean {
    const visibleFields = fields.filter((field) => {
      return field.visible || field.nestedFields.find((nested) => nested.visible);
    });
    const invalidFields = visibleFields.filter((field) => {
      return field.visible && (!field.valid || field.nestedFields.find((nested) => !nested.valid && nested.visible));
    });
    return invalidFields.length === 0;
  }
}
